import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Section, Reveal } from './Section';
import { CtaButton } from './CtaButton';
const includes = ['Ebook completo con conceptos + 3 estrategias', 'Acceso al Discord por 1 año', 'Bono 01 — Calculadora de gestión de riesgo', 'Bono 02 — Plantilla de backtesting', 'Bono 03 — 5 casos reales analizados'];
export function PricingSection() {
  return <Section id="precio" className="bg-ink-950 bg-grid" data-id="element-127" data-mp="1nb25bv8g0zc6">
      <Reveal data-id="element-128" data-mp="1naahj6l385wg">
        <div className="mx-auto max-w-xl" data-id="element-129" data-mp="1ncwph7bw4nf7">
          <div className="relative overflow-hidden rounded-3xl border border-brand/30 bg-ink-900 p-8 shadow-[0_20px_80px_-30px_rgba(34,197,94,0.35)] sm:p-10" data-id="element-130" data-mp="1s8luhq6oiwiw">
            <div aria-hidden="true" className="pointer-events-none absolute -right-16 -top-16 h-52 w-52 rounded-full bg-brand/10 blur-3xl" data-id="element-131" data-mp="227t6oa1ogl4f" />
            <div className="relative" data-id="element-132" data-mp="2vqpx7kfu4ug">
              <h2 className="font-display font-bold text-white sm:text-xl text-[26px]" data-id="element-133" data-mp="2ws59o8hldhz">
                Capital Consciente
              </h2>
              <p className="mt-1 text-sm text-gray-400" data-id="element-134" data-mp="1mh6gan378fzn">
                Ebook + Discord + 3 Bonos
              </p>

              <div className="my-6 inline-flex items-center gap-2 rounded-full border border-brand/30 bg-brand-soft px-4 py-2 text-xs font-bold text-gray-100 sm:text-sm" data-id="element-135" data-mp="1howvtmkus84r">
                <span className="relative flex h-2 w-2" aria-hidden="true" data-id="element-136" data-mp="17sae36ntpx6y">
                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-brand opacity-60" data-id="element-137" data-mp="17pxpiank8okx" />
                  <span className="relative inline-flex h-2 w-2 rounded-full bg-brand" data-id="element-138" data-mp="20gphsx1i8t2z" />
                </span>
                +200 se sumaron esta semana 🟢
              </div>

              <div className="flex flex-wrap items-center gap-x-3 gap-y-2" data-id="element-139" data-mp="1vj7gnstqbi5j">
                <span className="font-display text-lg font-semibold text-gray-500 line-through" data-id="element-140" data-mp="1rfhufa0j1cno">
                  $69.000
                </span>
                <span className="rounded-md bg-red-600 px-2 py-1 text-xs font-bold text-white" data-id="element-141" data-mp="g02y88g56otm">
                  -59%
                </span>
                <span className="text-sm font-semibold text-brand" data-id="element-142" data-mp="hiazhi29xzlv">
                  Ahorrás $41.010
                </span>
              </div>

              <div className="mt-2 flex items-end gap-2" data-id="element-143" data-mp="7ju6kfjrzax6">
                <span className="font-display text-5xl font-extrabold tracking-tight text-white sm:text-6xl" data-id="element-144" data-mp="7jc1ctf4xmd4">
                  $27.990
                </span>
                <span className="mb-2 text-sm font-medium text-gray-400" data-id="element-145" data-mp="3uwed4d1w4lr6">
                  ARS
                </span>
              </div>

              <p className="mt-4 rounded-xl border border-white/10 bg-ink-850 p-4 text-sm leading-relaxed text-gray-300" data-id="element-146" data-mp="3jbceeuetsrt">
                Una mentoría privada arranca en{' '}
                <span className="font-semibold text-white" data-id="element-147" data-mp="3pymjnellkrkv">$500 USD</span>. Esto
                te da el mismo camino de aprendizaje, sin esa barrera.
              </p>

              <ul className="mt-6 space-y-3" data-id="element-148" data-mp="3fz5fj1lzulr0">
                {includes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-149" data-mp="3g1i0zoqyne8t">
                    <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-brand-soft" data-id="element-150" data-mp="2xbwfrnbvgou9">
                      <CheckIcon className="h-3.5 w-3.5 text-brand" data-id="element-151" data-mp="2se39kuakjutz" />
                    </span>
                    <span className="text-sm text-gray-300" data-id="element-152" data-mp="369oryimargdf">{item}</span>
                  </li>)}
              </ul>

              <div className="mt-8" data-id="element-153" data-mp="31f1ctad6nybi">
                <CtaButton href="https://librofy-store.myshopify.com/checkouts/cn/hWNEmBVLccQ7eA1bRokttDFq/es-ar?_r=AQABfAihuCbzijztfFezpOtyDt4pCKBObXocP11lxypOBK4&cart_link_id=UO5y7BLn&preview_theme_id=160306823389_" size="lg" className="w-full" data-id="element-154" data-mp="3g95w2vlwhm7a">
                  SÍ, QUIERO ARRANCAR HOY
                </CtaButton>
              </div>

              <p className="mt-4 text-center text-xs text-gray-500" data-id="element-155" data-mp="3l1h6wti6isem">
                🛡️ Garantía 30 días · 🔒 Pago seguro · 💳 Mercado Pago
              </p>
            </div>
          </div>
        </div>
      </Reveal>
    </Section>;
}